export const LIST_PACKAGE_ADDITIONAL_INFO_REQUEST = 'LIST_PACKAGE_ADDITIONAL_INFO_REQUEST'
export const LIST_PACKAGE_ADDITIONAL_INFO_SUCCESS = 'LIST_PACKAGE_ADDITIONAL_INFO_SUCCESS'
export const LIST_PACKAGE_ADDITIONAL_INFO_FAILURE = 'LIST_PACKAGE_ADDITIONAL_INFO_FAILURE'

export const LIST_PACKAGE_ADDITIONAL_INFO_SUMMARY_REQUEST = 'LIST_PACKAGE_ADDITIONAL_INFO_SUMMARY_REQUEST'
export const LIST_PACKAGE_ADDITIONAL_INFO_SUMMARY_SUCCESS = 'LIST_PACKAGE_ADDITIONAL_INFO_SUMMARY_SUCCESS'
export const LIST_PACKAGE_ADDITIONAL_INFO_SUMMARY_FAILURE = 'LIST_PACKAGE_ADDITIONAL_INFO_SUMMARY_FAILURE'

export const CREATE_PACKAGE_ADDITIONAL_INFO_REQUEST = 'CREATE_PACKAGE_ADDITIONAL_INFO_REQUEST'
export const CREATE_PACKAGE_ADDITIONAL_INFO_SUCCESS = 'CREATE_PACKAGE_ADDITIONAL_INFO_SUCCESS'
export const CREATE_PACKAGE_ADDITIONAL_INFO_FAILURE = 'CREATE_PACKAGE_ADDITIONAL_INFO_FAILURE'

export const DETAIL_PACKAGE_ADDITIONAL_INFO_REQUEST = 'DETAIL_PACKAGE_ADDITIONAL_INFO_REQUEST'
export const DETAIL_PACKAGE_ADDITIONAL_INFO_SUCCESS = 'DETAIL_PACKAGE_ADDITIONAL_INFO_SUCCESS'
export const DETAIL_PACKAGE_ADDITIONAL_INFO_FAILURE = 'DETAIL_PACKAGE_ADDITIONAL_INFO_FAILURE'

export const UPDATE_PACKAGE_ADDITIONAL_INFO_REQUEST = 'UPDATE_PACKAGE_ADDITIONAL_INFO_REQUEST'
export const UPDATE_PACKAGE_ADDITIONAL_INFO_SUCCESS = 'UPDATE_PACKAGE_ADDITIONAL_INFO_SUCCESS'
export const UPDATE_PACKAGE_ADDITIONAL_INFO_FAILURE = 'UPDATE_PACKAGE_ADDITIONAL_INFO_FAILURE'

export const DELETE_PACKAGE_ADDITIONAL_INFO_REQUEST = 'DELETE_PACKAGE_ADDITIONAL_INFO_REQUEST'
export const DELETE_PACKAGE_ADDITIONAL_INFO_SUCCESS = 'DELETE_PACKAGE_ADDITIONAL_INFO_SUCCESS'
export const DELETE_PACKAGE_ADDITIONAL_INFO_FAILURE = 'DELETE_PACKAGE_ADDITIONAL_INFO_FAILURE'

export const RESET_STATE_PACKAGE_ADDITIONAL_INFO = 'RESET_STATE_PACKAGE_ADDITIONAL_INFO'

